import styled from 'styled-components';
import * as variables from "pubweb-smokey/dist/components/GridSystem/_vars_widths";
import Colors from "pubweb-smokey/dist/colors";

export const LearnStyles = styled.div`
    @media screen and (min-width: ${variables.mobile_width_percentage}px) {
        .learn {
            background-color: #f2f2f2;
            font-family: "acumin-pro", Arial, Helvetica, sans-serif;
            padding-top: 28px;

            .learn-articles {
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                margin: 2% 2% 0 2%;
            }
            h6 {
                color: #0976bc;
                font-size: 33px;
                font-weight: bolder;
                margin: 0 auto 28px auto;
                text-align: center;
            }
            .learn-article {
                    background-color: #fff;
                    margin-bottom: 10px;
                    max-width: 248px;
                    text-align: center;
                    text-decoration: none;
                    width: 48%;
                    img {
                        width: 100%;        
                    }
                    h4 {
                        color: #797979;
                        font-size: 13px;
                        height: 50px;
                    }
                    p {
                        color: #4ad1c7;
                        font-weight: bold;
                    }
                }
            }
        .modal-container {
            border-radius: 4px;
            padding: 0;
            height: 90%;
            width: 95%;
            .modal-content {
                height: 100%;
                margin: auto;
                max-height: unset;
                overflow: hidden;
                width: 100%;
            }
            iframe {
                margin-top: 2%;
            }
            .nav-hider {
                background-color: #fff;
                cursor: default;
                height: 67px;
                position: absolute;
                width: 100%;
            }
            button {
                background: linear-gradient(to bottom, #40b0f7 0%, #0976bc 100%);
                border-radius: 0.4rem;
                color: #fff;
                cursor: pointer;
                font-size: 13px;
                font-weight: 700;
                margin: 5px;
                position: absolute;
                right: 0;
                top: 20px;
                z-index: 20;
            }
        }
    }

    @media screen and (min-width: 768px) {
        .learn {
            h6 {
                font-size: 44px;
            }        
            .learn-articles {
                justify-content: space-around;
                .learn-article {
                    cursor: pointer;
                    margin-bottom: 35px;
                    h4 {
                        font-size: 17px;
                    }
                }       
            } 
        }
    }

    @media screen and (min-width: 1024px) {
        .learn {
            .learn-articles {
                justify-content: space-evenly;
                margin: 0;
                .learn-article {
                    margin: 10px 0 50px 0;
                }
            }
        }
    }
`;